<template>
  <div v-if="conversationTimeWindowExpired && !canScheduleMessage" class="mt-5 mb-5">
      <div class="relative ml-16 mr-16">
        <div class="absolute inset-0 flex items-center" aria-hidden="true">
          <div class="w-full border-t border-gray-300" />
        </div>
        <div class="relative flex justify-center">
          <button @click="showContextMenuForWhatsapp" type="button" class="items-center shadow-sm px-4 py-1.5 border border-gray-300 text-sm leading-5 rounded-full text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
            <span class="block mb-2 pt-1 pl-2 pr-2">{{ $t('conversation.timeWindowExpired') }}</span>
            <span class="block pb-1 pl-2 pr-2" v-if="isWhatsappChannel && hasWhatsappMessages">{{ $t('conversation.timeWindowExpiredMoreWhatsapp') }}</span>
            <span class="block pb-1 pl-2 pr-2" v-else>{{ $t('conversation.timeWindowExpiredMore') }}</span>
          </button>
        </div>
      </div>
    </div>
    <div v-if="allChannelsDeleted" class="mt-5 mb-5">
      <VLink href="/settings" class="block">
        <div class="relative ml-16 mr-16">
          <div class="absolute inset-0 flex items-center" aria-hidden="true">
            <div class="w-full border-t border-gray-300" />
          </div>
          <div class="relative flex justify-center">
            <button type="button" class="inline-flex items-center shadow-sm px-4 py-1.5 border border-gray-300 text-sm leading-5 rounded-full text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
              <span>{{ $t('conversation.deletedComeback') }}</span>
            </button>
          </div>
        </div>
      </VLink>
    </div>
</template>


<script>
import VLink from '../../page/VLink.vue'



export default {
  name: 'EndOfLifeMessages',
  props: ['conversationTimeWindowExpired', 'canScheduleMessage', 'allChannelsDeleted', 'isWhatsappChannel', 'hasWhatsappMessages'],
  emits: ['whatsapp-context-menu-requested'],
  components: {
    VLink,
  },
  methods: {
    showContextMenuForWhatsapp() {
      this.$emit('whatsapp-context-menu-requested');
    },
  },
}
</script>
